export default {
  registration: {
    header: {
      title: 'Página de registro de proveedores',
      // title_esg_data_share: '',
    },
    passcode: {
      section_one: 'Esta es una página de registro de usuarios para empresas a las que se ha solicitado utilizar este servicio.',
      section_two: 'Introduzca una contraseña para acceder a la página de registro.',
      section_three: 'Si no ha recibido un código de acceso, póngase en contacto con la empresa que solicitó utilizar este servicio.',
      passcode: 'Código de acceso',
      passcode_placeholder: '@:common.form.search_word.placeholder',
      incomplete_input: 'Datos incorrectos.',
      unexpected_error: 'Ha ocurrido un error inesperado',
    },
    email: {
      section_one: '@:registration.passcode.section_one',
      section_two: 'Ingrese su dirección de correo electrónico para registrarse.',
      email: 'Correo electrónico',
      email_placeholder: 'Introduzca su dirección de correo electrónico',
    },
    sent: {
      section_one: 'Se envió un correo electrónico a la dirección de correo electrónico.',
      section_two: 'Compruebe la URL del correo electrónico y proceda al registro de la cuenta.',
      section_three: 'Si no recibe un correo electrónico dentro de 30 minutos, contáctenos en',
      section_four: '.',
    },
    password: {
      // TODO: section_one は日本語だと「アスエネ/アスエネESGの」を「アスエネ関連プロダクトの」に変更する対応が入っており、本言語にはそれが未反映
      section_one: 'La dirección de correo electrónico que introdujo ya está registrada en una cuenta de ASUENE/ASUENE ESG.',
      section_two: 'Inicie sesión con su contraseña.',
      password: 'Contraseña',
      // password_placeholder: '',
      error_auth: 'Autenticación fallida. Por favor inicie sesión de nuevo',
      // error_linking: '',
      // same_domain_modal: {
      //   title: '',
      //   section: '',
      // },
    },
    info: {
      section_one: '@:registration.passcode.section_one',
      section_two: 'Introduzca la información necesaria para completar su registro.',
      section_three: 'Inicie sesión con su cuenta registrada tras la solicitud y podrá responder a la nueva encuesta.',
      buyer_name: 'Comprador',
      // expires_date: '',
      deadline: '@:common.date.answer_expires_date',
    },
    form: {
      invalid_form: '@:settings.messages.invalid_form',
      company_name: 'Nombre de empresa',
      company_name_placeholder: '@:common.company_name_inc',
      company_scale: '@:settings.company.scale',
      select_placeholder: '@:upload_common.target_select',
      industry_type: '@:settings.company.industry_type',
      first_name: '@:settings.user.first_name',
      last_name_placeholder: 'Yamada',
      last_name: '@:settings.user.last_name',
      first_name_placeholder: 'Taro',
      email: '@:settings.user.email',
      email_placeholder: '@:settings.user.email',
      email_text: 'Se muestra la dirección de correo electrónico que introdujo',
      phone: 'Número telefónico',
      phone_placeholder: '0000000000',
      locale: 'Seleccione idioma',
      section_one: 'Por favor, acepte los ',
      rule: 'Términos y Condiciones',
      rule_link: '/pdf/241112_AsueneESG_Terms_and_Conditions_Supplier.pdf',
      punctuation: ' y la ',
      policy: 'Política de Privacidad',
      policy_link: 'https://asuene.com/en/privacy',
      section_two: ' antes de continuar.',
      // same_domain_modal: {
      //   title: '',
      //   section: '',
      // },
    },
    thanks: {
      section_one: 'Gracias por registrarse.',
      section_two: 'Hemos enviado su nombre de usuario y contraseña a la dirección de correo electrónico que introdujo.',
      section_three: 'Compruebe su correo electrónico y siga las instrucciones para iniciar sesión.',
      section_four: 'Si no recibe un correo electrónico dentro de 30 minutos, contáctenos en',
      section_five: '',
      section_six: 'Un responsable se pondrá en contacto con usted.',
    },
    expired: {
      section_one: 'La URL proporcionada ya ha caducado',
      section_two: 'Si desea utilizar este servicio, póngase en contacto con ',
      section_three: 'Un responsable se pondrá en contacto con usted.',
    },
    error: {
      section_one: 'No se pudo encontrar la URL proporcionada.',
      section_two: 'Disculpe las molestias, pero le rogamos que vuelva a consultar la URL.',
    },
    btn: {
      submit: 'Enviar',
      service_top: 'Inicio',
      login: 'Inicio de sesión',
      register: 'Registrar',
      rating_url: 'https://asuene.com/rating/en',
    },
    buyer: {
      // sharing_company: "",
      // explain_message: "",
    },
  },
}
